import React from 'react';

// Fonts
import './style.css';

const ExoFont = (props) => {
    return (
        <div className={props.className} style={props.style}>
            {props.children}
        </div>
    );
}

export default ExoFont;